import RegisterEmployeeDashboard from './RegisterEmployeeDashboard';
export default RegisterEmployeeDashboard;
